module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "passWord"
    }
  }, [(_vm.seted) ? _c('div', {
    staticClass: "box-center"
  }, [_vm._v("\n    请输入旧密码\n  ")]) : [(_vm.show) ? _c('div', {
    staticClass: "box-center"
  }, [_vm._v("\n      请输入密码\n    ")]) : _c('div', {
    staticClass: "box-center"
  }, [_vm._v("\n      请确认密码\n    ")])], _vm._v(" "), _c('van-password-input', {
    attrs: {
      "value": _vm.value,
      "info": "密码为 6 位数字"
    },
    on: {
      "focus": function($event) {
        _vm.showKeyboard = true
      }
    }
  }), _vm._v(" "), _c('van-number-keyboard', {
    attrs: {
      "show": _vm.showKeyboard
    },
    on: {
      "input": _vm.onInput,
      "delete": _vm.onDelete,
      "blur": function($event) {
        _vm.showKeyboard = false
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b94a1a0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/passWord.vue
// module id = 442
// module chunks = 0